"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParser = exports.createSchemaValidator = exports.createValidator = void 0;
const ajv_formats_1 = __importDefault(require("ajv-formats"));
const _2019_1 = __importDefault(require("ajv/dist/2019"));
const errors_1 = require("./errors");
/**
 * Creates a JSON schema validator function to test against the provided schema.
 * @param schema describing the data shape the resulting validate function will
 * test against
 * @returns a function to validate an input object matches the given `schema`.
 */
function createValidator(schema, options) {
    const ajv = createSchemaValidator(options);
    const requestValidator = ajv.compile(schema);
    return requestValidator;
}
exports.createValidator = createValidator;
/**
 * Create an AJV validator configured with options and formats used by typebox.
 */
function createSchemaValidator(options) {
    return (0, ajv_formats_1.default)(new _2019_1.default(options ?? {}), [
        'date-time',
        'time',
        'date',
        'email',
        'hostname',
        'ipv4',
        'ipv6',
        'uri',
        'uri-reference',
        'uuid',
        'uri-template',
        'json-pointer',
        'relative-json-pointer',
        'regex',
    ])
        .addKeyword('kind')
        .addKeyword('modifier');
}
exports.createSchemaValidator = createSchemaValidator;
/**
 * Create a validator function which can be used to confirm if the given input
 * matchs the `schema`.
 * @throws ValidationError if input is not valid against `schema`
 */
function createParser(schema) {
    const isValid = createValidator(schema);
    return (value) => {
        if (isValid(value)) {
            return value;
        }
        else {
            throw new errors_1.ValidationError(isValid.errors ?? []);
        }
    };
}
exports.createParser = createParser;
